import { useTranslation } from 'react-i18next'

import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'

type Props = {
    open: boolean
    title: string
    message: string
    confirmText?: string
    cancelText?: string
    onClose: () => void
    onConfirm: () => void
}
export default function DialogConfirm({
    open,
    title,
    message,
    confirmText,
    cancelText,
    onClose,
    onConfirm,
}: Props) {
    const { t } = useTranslation()

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <DialogContentText>{message}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button sx={{ color: 'text.secondary' }} onClick={onClose}>
                    {cancelText || t('cancel')}
                </Button>
                <Button disableElevation variant="contained" onClick={onConfirm}>
                    {confirmText || t('confirm')}
                </Button>
            </DialogActions>
        </Dialog>
    )
}
